import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import {
    Table,
    Pagination,
    message,
    Row,
    Col,
    Icon,
    Card,
    Form,
    Input,
    Switch,
    Modal,
    Select,
    Button,
    DatePicker,
    Spin,
    Statistic,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

// 表单数据
const formData = {
    date: undefined,
    email: undefined,
}

export default class Overview extends React.Component {
    state = {
        loading: false, // 是否加载中
        detailLoading: false, // 是否加载中
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        formData: { ...formData }, // 表单数据
        queryParams: {
            // 查询参数
            kind: 0,
        },
        dateList: [
            // 日期列表
            { value: 0, label: this.props.language["today"] },
            { value: 1, label: this.props.language["thisWeek"] },
            { value: 2, label: this.props.language["lastWeek"] },
            { value: 3, label: this.props.language["historyTotal"] },
        ],
        baseOverviewInfo: {}, // 基本概况信息
        detailOverviewInfo: {}, // 详细概况信息
    };

    async componentDidMount () {
        this.fetchBaseOverviewInfo();
        this.fetchDetailOverviewInfo();
    }

    /**
     * 获取基本概况信息
     */
    fetchBaseOverviewInfo = async () => {
        this.setState({ loading: true });
        let res = await axios.get(`/v1/api/union_overview`);
        this.setState({
            loading: false,
            baseOverviewInfo: res.data || {},
        });
    };

    /**
     * 获取详细概况信息
     */
    fetchDetailOverviewInfo = async () => {
        this.setState({ detailLoading: true });
        let res = await axios.get(`/v1/api/union_overview_stat`, {
            params: {
                ...this.state.queryParams,
            },
        });
        this.setState({
            detailLoading: false,
            detailOverviewInfo: res.data || {},
        });
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState(
            { queryParams: { ...this.state.queryParams, [key]: value } },
            () => {
                this.fetchDetailOverviewInfo();
            }
        );
    };

    /**
     * 显示弹窗
     */
    handleShow = (type) => {
        if (type === "export") {
            // 导出
            this.setState({
                title: this.props.language["exportAllLevels"],
                type,
                show: true,
            });
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false, formData: { ...formData } });
    }

    /**
     * 导出数据
     */
    handleExport = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .get("/v1/api/direct_union/export_agent_account_checking", {
                        params: {
                            begin_time: values.date[0] && values.date[0].startOf("day").valueOf() / 1000,
                            end_time: values.date[1] && values.date[1].startOf("day").valueOf() / 1000,
                            email: values.email,
                        },
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["exportSuccessMessage"]);
                            this.handleClose()
                        }
                    });
            }
        })
    };

    render () {
        return (
            <Spin spinning={this.state.loading}>
                <div className='p10'>
                    {/* 余额 */}
                    {Cookie.get("isDirect") === 'false' &&
                        <Card
                            title={<h2>{this.props.language["balance"]}</h2>}
                            type="inner"
                        >
                            <Row type="flex" align="middle">
                                {/* 柜台积分 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(this.state.baseOverviewInfo.point || 0)}
                                            />
                                            <p className="label">
                                                {this.props.language["counterPoint"]}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 柜台钻石 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(this.state.baseOverviewInfo.diamond || 0)}
                                            />
                                            <p className="label">
                                                {this.props.language["counterDiamond"]}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Card>
                    }

                    {/* 数据 */}
                    <Card
                        className="mt10"
                        title={
                            <Row type="flex" align="middle">
                                <h2 className="title">{this.props.language["data"]}</h2>
                                <Select
                                    className="ml10"
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder={this.props.language["datePlaceholder"]}
                                    style={{ width: 120 }}
                                    value={this.state.queryParams.kind}
                                    onChange={(value) =>
                                        this.handleSetQueryParamsData("kind", value)
                                    }
                                >
                                    {this.state.dateList.map((item, index) => (
                                        <Select.Option key={index} value={item.value}>
                                            {item.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                                {Cookie.get("isDirect") === 'true' &&
                                    <Button
                                        type="default"
                                        icon="arrow-down"
                                        className="btn-yellow-ghost ml20"
                                        onClick={() => this.handleShow("export")}
                                    >
                                        {this.props.language["exportAllLevels"]}
                                    </Button>
                                }
                            </Row>
                        }
                        type="inner"
                    >
                        <Spin spinning={this.state.detailLoading}>
                            <Row type="flex" align="middle">
                                {/* 利润 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(
                                                    this.state.detailOverviewInfo.income_sum || 0
                                                )}
                                                valueStyle={{
                                                    color:
                                                        this.state.detailOverviewInfo.income_sum > 0
                                                            ? "#3f8600"
                                                            : this.state.detailOverviewInfo.income_sum < 0
                                                                ? "#cf1322"
                                                                : "",
                                                }}
                                            />
                                            <p className="label">{this.props.language["gain"]}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* 玩家PVP游戏盈亏 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(
                                                    this.state.detailOverviewInfo.pvp_profit_sum || 0
                                                )}
                                                valueStyle={{
                                                    color:
                                                        this.state.detailOverviewInfo.pvp_profit_sum > 0
                                                            ? "#3f8600"
                                                            : this.state.detailOverviewInfo.pvp_profit_sum < 0
                                                                ? "#cf1322"
                                                                : "",
                                                }}
                                            />
                                            <p className="label">
                                                {this.props.language["pvpProfitSum"]}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 服务费 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(
                                                    this.state.detailOverviewInfo.fee_sum || 0
                                                )}
                                                valueStyle={{
                                                    color:
                                                        this.state.detailOverviewInfo.fee_sum > 0
                                                            ? "#3f8600"
                                                            : this.state.detailOverviewInfo.fee_sum < 0
                                                                ? "#cf1322"
                                                                : "",
                                                }}
                                            />
                                            <p className="label">
                                                {this.props.language["serviceFee"]}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 玩家保险盈亏 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(
                                                    this.state.detailOverviewInfo.ins_profit_sum || 0
                                                )}
                                                valueStyle={{
                                                    color:
                                                        this.state.detailOverviewInfo.ins_profit_sum > 0
                                                            ? "#3f8600"
                                                            : this.state.detailOverviewInfo.ins_profit_sum < 0
                                                                ? "#cf1322"
                                                                : "",
                                                }}
                                            />
                                            <p className="label">
                                                {this.props.language["insProfitSum"]}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 玩家牛仔盈亏 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(
                                                    this.state.detailOverviewInfo.cb_profit_sum || 0
                                                )}
                                                valueStyle={{
                                                    color:
                                                        this.state.detailOverviewInfo.cb_profit_sum > 0
                                                            ? "#3f8600"
                                                            : this.state.detailOverviewInfo.cb_profit_sum < 0
                                                                ? "#cf1322"
                                                                : "",
                                                }}
                                            />
                                            <p className="label">
                                                {this.props.language["cbProfitSum"]}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 游戏人数 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(
                                                    this.state.detailOverviewInfo.player_sum || 0
                                                )}
                                            />
                                            <p className="label">
                                                {this.props.language["gamePepoleNumber"]}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 牌局数 */}
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(
                                                    this.state.detailOverviewInfo.match_sum || 0
                                                )}
                                            />
                                            <p className="label">
                                                {this.props.language["matchSum"]}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Spin>
                    </Card>

                    {/* 下级 */}
                    <Card
                        className="mt10"
                        title={<h2>{this.props.language["lower"]}</h2>}
                        type="inner"
                    >
                        <Row type="flex" align="middle">
                            {/* 联盟 */}
                            {Cookie.get("unionType") === "super_union" && (
                                <div className="number-box-list">
                                    <div className="value-list">
                                        <div className="value-item">
                                            <Statistic
                                                value={Number(
                                                    this.state.baseOverviewInfo.sub_union_num || 0
                                                )}
                                            />
                                            <p className="label">{this.props.language["unionMaster"]}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* 俱乐部 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(this.state.baseOverviewInfo.club_num || 0)}
                                        />
                                        <p className="label">{this.props.language["club"]}</p>
                                    </div>
                                </div>
                            </div>

                            {/* 玩家 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(
                                                this.state.baseOverviewInfo.member_num || 0
                                            )}
                                        />
                                        <p className="label">{this.props.language["player"]}</p>
                                    </div>
                                </div>
                            </div>

                            {/* 超级代理 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(
                                                this.state.baseOverviewInfo.super_agent_num || 0
                                            )}
                                        />
                                        <p className="label">{this.props.language["superProxy"]}</p>
                                    </div>
                                </div>
                            </div>

                            {/* 一级代理 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(
                                                this.state.baseOverviewInfo.agent_one_num || 0
                                            )}
                                        />
                                        <p className="label">{this.props.language["oneProxy"]}</p>
                                    </div>
                                </div>
                            </div>

                            {/* 二级代理 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(
                                                this.state.baseOverviewInfo.agent_two_num || 0
                                            )}
                                        />
                                        <p className="label">{this.props.language["twoProxy"]}</p>
                                    </div>
                                </div>
                            </div>

                            {/* 三级代理 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(
                                                this.state.baseOverviewInfo.agent_three_num || 0
                                            )}
                                        />
                                        <p className="label">{this.props.language["threeProxy"]}</p>
                                    </div>
                                </div>
                            </div>

                            {/* 四级代理 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(
                                                this.state.baseOverviewInfo.agent_four_num || 0
                                            )}
                                        />
                                        <p className="label">{this.props.language["fourProxy"]}</p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Card>
                </div>

                {/* 导出弹窗 */}
                <ExportFormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    onOk={this.handleExport}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </Spin>
        );
    }
}

/**
 * 导出弹窗
 */
const ExportFormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["timeRange"]}>
                                {getFieldDecorator("date", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["timeRangeVerify"],
                                        },
                                    ],
                                    initialValue: this.props.formData.date,
                                })(
                                    <DatePicker.RangePicker />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["emailAccount"]}>
                                {getFieldDecorator("email", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["emailAccountVerify"],
                                        },
                                    ],
                                    initialValue: this.props.formData.email,
                                })(
                                    <Input
                                        maxLength={60}
                                        allowClear
                                        placeholder={this.props.language["emailAccountPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);
